<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-toolbar-title>
                    {{ $t('terms_and_conditions') }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="col-12">
                    <span v-html="getTerm"></span>
                </div>

                <div class="row gutter-sm justify-end q-mt-lg">
                    <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                        <q-btn color="red-9" class="full-width" :label="$t('refuse')" icon="fas fa-ban" @click="refuse()" />
                    </div>

                    <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                        <q-btn color="green-9" class="full-width" :label="$t('accept')" icon="fas fa-check" @click="accept()" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "login"] },
    data() {
        return {
            terms: [],
            show_modal: false,
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            accept_terms_and_conditions: 'common/accept_terms_and_conditions',
            id_user_language_selected: 'common/id_user_language_selected',
            register: 'params/register',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getTerm() {
            let obj = this.terms.find((obj) => { return obj.language === this.id_user_language_selected && obj.body !== null })
            if (obj) {
                return obj.body
            }
            else {
                let obj = this.terms.find((obj) => { return obj.body !== '' })
                if (obj) {
                    return obj.body
                }
            }
            return ''
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

    },
    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get('/etraining_login/terms/', this.getHeader)
	        .then(response => {
                this.terms = response.data
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.show_modal = true
                this.$q.loading.hide()
            })
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        refuse() {
            this.$store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])

            firebase.auth().signOut().then(() => {

            }).catch((e) => {
                console.log(e)
            })

            setTimeout(() =>{
                this.$q.loading.hide()
                this.$router.replace({ name: 'login' })
            }, 700)
        },

        accept() {
            this.loading = true

            let fd = new FormData()
            fd.append('accept', true)

            this.$axios.post('/register_user/user_accept_terms_and_conditions/', fd, this.getHeader)
            .then(response => {
                this.loading = false
                this.show_modal = false

                this.$store.dispatch('common/SET_TERMS_AND_CONDITIONS', [response.data.date_hour_accept])
            })
            .catch(e => {
                console.log(e)
                this.loading = false
            })
        }
    },

    created() {
        if(this.register.use_accept_terms === true && !this.accept_terms_and_conditions) {
            this.fetchData()
        }
    }
}
</script>

<style>

</style>